





























import { Component, Prop, Vue } from "vue-property-decorator";
import { Row } from "@/types/section";
import SocialIcon from "@/components/SocialIcon.vue";

@Component({
  components: {
    SocialIcon
  }
})
export default class SectionRow extends Vue {
  @Prop({ type: Object, required: true }) private row!: Row;
}
